import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import { useCurrentWorkspace } from './workspace';

export interface SearchResult {
  type: 'task' | 'project' | 'chat' | 'notification';
  title: string;
  subtitle: string | null;
  link: string;
}

/**
 * Global content search within the current workspace — tasks, projects, chat
 * messages and notifications. Only runs for queries of 2+ characters.
 */
export function useSearch(query: string) {
  const ws = useCurrentWorkspace();
  const q = query.trim();
  return useQuery({
    queryKey: ['search', ws?.publicId, q],
    queryFn: () =>
      api<{ data: SearchResult[] }>(
        `/workspaces/${ws!.publicId}/search?q=${encodeURIComponent(q)}`,
      ).then((r) => r.data),
    enabled: !!ws && q.length >= 2,
    staleTime: 10_000,
  });
}
